import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { WasteOrderStatus } from '../../interfaces/configuration/waste-order-status';

@Injectable()

export class WasteOrderStatusService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<WasteOrderStatus[] | boolean> {
    return new Observable<WasteOrderStatus[] | boolean>((o: Subscriber<WasteOrderStatus[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.waste-order.status.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WasteOrderStatus[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<WasteOrderStatus | boolean> {
    return new Observable<WasteOrderStatus | boolean>((o: Subscriber<WasteOrderStatus | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.waste-order.status.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<WasteOrderStatus>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  sort(formData: any): Observable<ServerResponse> {
    return this.api.sort(this.apiEndpoints.get('configuration.waste-order.status.sort'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('configuration.waste-order.status.update', {':id': id}), formData);
  }

  copy(id: number): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('configuration.waste-order.status.copy', {':id': id}));
  }
}
